/**
 * Russian API errors that carry a value inside them.
 *
 * The exact-text table in apiErrorKeys.js cannot match these, because the backend builds
 * them around an id, a file name or a limit. Each pattern keeps that value untouched and
 * translates only the Russian frame around it (I18N-08).
 */
export const API_ERROR_PATTERNS = Object.freeze([
  { key: 'unknown_platform', pattern: /^Неизвестная платформа: (?<value>.+)$/ },
  { key: 'unknown_provider', pattern: /^Неизвестный провайдер: (?<value>.+)$/ },
  { key: 'unknown_entity', pattern: /^Неизвестный тип сущности: (?<value>.+)$/ },
  { key: 'unknown_action', pattern: /^Неизвестный тип действия: (?<value>.+)$/ },
  { key: 'unknown_status', pattern: /^Неизвестный статус: (?<value>.+)$/ },
  { key: 'unknown_operation', pattern: /^Неизвестная операция: (?<value>.+)$/ },
  { key: 'unknown_category', pattern: /^Неизвестная категория: (?<value>.+)$/ },
  { key: 'unknown_repackaging', pattern: /^Неизвестный тип перепаковки: (?<value>.+)$/ },
  { key: 'unknown_type', pattern: /^Неизвестный тип: (?<value>.+)$/ },
  { key: 'file_not_found', pattern: /^Файл не найден: (?<value>.+)$/ },
  { key: 'video_not_found', pattern: /^Видео не найдено: (?<value>.+)$/ },
  { key: 'template_not_found', pattern: /^Шаблон (?<value>.+) не найден$/ },
  { key: 'widget_not_found', pattern: /^Виджет (?<value>.+) не найден$/ },
  { key: 'password_too_short', pattern: /^Пароль должен содержать минимум (?<value>\d+) символов$/ },
  { key: 'new_password_too_short', pattern: /^Новый пароль должен содержать минимум (?<value>\d+) символов$/ },
  { key: 'rate_limited', pattern: /^Слишком много запросов\. Повторите попытку через (?<value>\d+) сек\.$/ },
  { key: 'generation_failed', pattern: /^Ошибка генерации: (?<value>.+)$/ },
  { key: 'analysis_failed', pattern: /^Ошибка анализа: (?<value>.+)$/ },
  { key: 'parsing_failed', pattern: /^Ошибка парсинга: (?<value>.+)$/ },
  { key: 'request_failed', pattern: /^Ошибка запроса: (?<value>.+)$/ },
  { key: 'delete_failed', pattern: /^Ошибка удаления: (?<value>.+)$/ },
  { key: 'save_file_failed', pattern: /^Не удалось сохранить файл: (?<value>.+)$/ },
  { key: 'url_load_failed', pattern: /^Не удалось загрузить URL: (?<value>.+)$/ },
  { key: 'ai_provider_unavailable', pattern: /^AI-провайдер недоступен: (?<value>.+)$/ },
  { key: 'model_answer_unparsable', pattern: /^Не удалось разобрать ответ модели: (?<value>.+)$/ },
  { key: 'transcription_failed', pattern: /^Транскрипция не удалась: (?<value>.+)$/ },
  { key: 'render_failed', pattern: /^Рендер не удался: (?<value>.+)$/ },
  { key: 'not_video_file', pattern: /^«(?<value>.+)» не распознан как видео — загрузите mp4, mov, mkv или webm\.$/ },
  { key: 'not_audio_file', pattern: /^«(?<value>.+)» не распознан как аудио — загрузите mp3, wav, m4a, ogg или aac\.$/ },
  { key: 'networks_not_connected', pattern: /^Не подключены платформы: (?<value>.+)\. Подключите их в настройках\.$/ },
  { key: 'accounts_not_connected', pattern: /^Нет подключённых аккаунтов: (?<value>.+)\. Подключите их в разделе публикации\.$/ },
  { key: 'project_domain_exists', pattern: /^Проект с доменом (?<value>.+) уже существует$/ },
  { key: 'proxy_exists', pattern: /^Прокси (?<value>.+) уже существует$/ },
  { key: 'invalid_params', pattern: /^Неверные параметры: (?<value>.+)$/ },
  { key: 'invalid_status_choices', pattern: /^Недопустимый статус\. Доступные: (?<value>.+)$/ },
]);
